<script setup>
import { ref, onBeforeMount } from 'vue';
import { useAuthStore } from '@stores/AuthStore';
import { useRouter } from 'vue-router';

const router = useRouter();
const authStore = useAuthStore();

const redirectIsAuth = (path) => {
    router.replace(path);
};

const logout = async () => {
    await authStore.logout();
    redirectIsAuth('/auth');
    window.location.reload();
};

onBeforeMount(() => {
    logout();
});
</script>
